const {Component} = require("react");
const {arrayEquals} = require("helpers/array");
const Load = require("components/mixins/Load");
const BeforeUnload = require("helpers/BeforeUnload");

class Form extends Component {

	constructor(props) {
		super(props);

		this.state = {
			errors: {},
			message: null,
			loading: false,
		};
	}

	componentDidMount() {
		const errorName = (element) => {
			const name = element.name || element.dataset.name;
			return name ? name.replace(/\[/g, ".").replace(/\]/g, "") : null;
		};

		// Drop errors when elements change or focus
		const dropError = (e) => {
			const name = errorName(e.target);

			if (typeof name === "string" && this.state.errors[name]) {
				this.setState(state => {
					delete state.errors[name];
					return state;
				});
			}
		};

		if (this.shouldWarn) {
			this.form.addEventListener("change", BeforeUnload.set);
		}

		this.form.addEventListener("change", dropError, true);
		this.form.addEventListener("input", dropError, true);
	}

	/////////////////////////////////
	// Accessors
	/////////////////////////////////

	get successMessage() {
		return "Oplysningerne er blevet opdateret.";
	}

	get actionLabel() {
		return "Indsend";
	}

	get className() {
		let list = this.props.className || '';
		return this.state.loading ? list + " loading" : list;
		
	}

	get formProps() {
		return {};
	}

	get loading() {
		return this.state.loading;
	}

	get shouldWarn() {
		return false;
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	send(form) {
		// ...
	}

	afterSuccess() {
		BeforeUnload.clear();
	}

	handleErrors(errors) {
		this.setState({
			loading: false,
			message: null,
			errors: errors
		});
	}

	handleSuccess(message) {
		this.setState({
			loading: false,
			message: message,
			errors: {}
		});
	}

	error(name) {
		return this.state.errors[name] ? this.state.errors[name][0] : null;
	}

	errors(namespace) {
		const namespaceParts = namespace.split(".");

		return Object.keys(this.state.errors).reduce((acc, key) => {
			const keyParts = key.split(".");
			const keyNamespaceParts = keyParts.slice(0, namespaceParts.length);
			const keyName = keyParts.slice(namespaceParts.length).join(".");

			if (arrayEquals(namespaceParts, keyNamespaceParts)) {
				acc[keyName] = this.state.errors[key][0];
			}

			return acc;
		}, {});
	}

	value(name) {
		// ...
	}

	submit(manipulate = null) {
		// Set submitting state
		this.setState({loading: true, errors: {}, message: null});

		let status = this.send(this.form);

		if (typeof manipulate === "function") {
			status = manipulate(status);
		}

		if (status === false) {
			return this.setState({loading: false});
		}

		if (status === true) {
			this.handleSuccess(this.successMessage);
			this.afterSuccess();
		}

		if (status && typeof status.then === "function") {
			return status
				.then(() => this.handleSuccess(this.successMessage))
				.then(() => this.afterSuccess())
				.catch(xhr => {
					let errors = {message: 'Something went wrong'};

					if (!xhr || !xhr.response || !xhr.response.data || !xhr.response.data.errors) {
						this.handleErrors(errors);
					} else {
						this.handleErrors(xhr.response.data.errors)
					}
				});
		}
	}

	/////////////////////////////////
	// Listeners
	/////////////////////////////////

	onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		this.submit();
	};

	setWarning = () => {
		BeforeUnload.set();
	}

	/////////////////////////////////
	// Renderers
	/////////////////////////////////

	render() {
		return (
			<form className={this.className} ref={el => this.form = el} onSubmit={this.onSubmit} {...this.formProps}>
				{this.renderHeader()}
				{this.renderBody()}
				{this.renderFooter()}
			</form>
		);
	}

	renderHeader() {

	}

	renderBody() {

	}

	renderMessage() {
		const errs = Object.keys(this.state.errors);
		const hasErrs = errs.length > 0;

		if (hasErrs) {
			return (<div className="message has-errors">
				{this.state.errors[errs[0]] [0]}
			</div>);
		}

		if (this.state.message) {
			return (<div className="message">
				{this.state.message}
				<div className="checkmark-container">
					<svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
						<circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
						<path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
					</svg>
				</div>
			</div>);
		}
	}

	renderActions() {

	}

	renderFooter() {
		return (
			<div className="form-footer">
				{this.renderMessage()}
				<div className="actions">
					{this.renderActions()}
					<button type="submit" className="btn" disabled={this.loading}>{this.actionLabel}
						<Load></Load>
					</button>
				</div>
			</div>
		);
	}

}

module.exports = Form;



// WEBPACK FOOTER //
// ./resources/js/components/forms/Form.js